module.exports = __webpack_public_path__ + "static/media/anetwork5.6715bd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/anetwork5.png
// module id = 377
// module chunks = 0